// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiPolicy {
    static getAttributeTypeMap() {
        return PharmacyBiPolicy.attributeTypeMap;
    }
}
PharmacyBiPolicy.discriminator = undefined;
PharmacyBiPolicy.additionalProperties = false;
PharmacyBiPolicy.attributeTypeMap = [
    {
        "name": "number",
        "baseName": "number",
        "type": "string"
    },
    {
        "name": "type",
        "baseName": "type",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiPolicy.js.map